const a = ".sl-offcanvas{position:fixed;background:var(--sl-offcanvas-bg,hsl(var(--sl-hsl-card)));color:var(--sl-offcanvas-color,hsl(var(--sl-hsl-foreground)));border:1px solid var(--sl-offcanvas-border-color,hsl(var(--sl-hsl-border)));box-shadow:var(--sl-offcanvas-shadow,var(--sl-shadow-lg,0 10px 15px -3px rgb(0 0 0 / 0.1)));transition:transform var(--sl-offcanvas-transition,var(--sl-transition-normal,300ms)) ease;z-index:1000;display:flex;flex-direction:column}.sl-offcanvas__backdrop{position:fixed;inset:0;background:var(--sl-offcanvas-backdrop-bg,rgba(0,0,0,0.5));z-index:999;opacity:0;transition:opacity var(--sl-offcanvas-transition,var(--sl-transition-normal,300ms)) ease;pointer-events:none}.sl-offcanvas__backdrop::after{content:'';position:absolute;inset:0;background:inherit;opacity:inherit}.sl-offcanvas--start{top:0;left:0;height:100%;transform:translateX(-100%)}.sl-offcanvas--end{top:0;right:0;height:100%;transform:translateX(100%)}.sl-offcanvas--top{top:0;left:0;right:0;height:auto;max-height:80vh;transform:translateY(-100%)}.sl-offcanvas--bottom{bottom:0;left:0;right:0;height:auto;max-height:80vh;transform:translateY(100%)}.sl-offcanvas--sm{width:20rem}.sl-offcanvas--md{width:28rem}.sl-offcanvas--lg{width:36rem}.sl-offcanvas--full{width:100%}.sl-offcanvas--visible.sl-offcanvas--start,.sl-offcanvas--visible.sl-offcanvas--end{transform:translateX(0)}.sl-offcanvas--visible.sl-offcanvas--top,.sl-offcanvas--visible.sl-offcanvas--bottom{transform:translateY(0)}.sl-offcanvas--visible ~ .sl-offcanvas__backdrop{opacity:1;pointer-events:auto}.sl-offcanvas__container{display:flex;flex-direction:column;height:100%;overflow:hidden}.sl-offcanvas__header{display:flex;align-items:center;justify-content:space-between;padding:var(--sl-spacing-5,1.25rem);border-bottom:1px solid var(--sl-offcanvas-border-color,hsl(var(--sl-hsl-border)))}.sl-offcanvas__title{margin:0;font-size:var(--sl-font-size-xl,1.25rem);font-weight:var(--sl-font-weight-bold,700);color:var(--sl-offcanvas-color,hsl(var(--sl-hsl-foreground)))}.sl-offcanvas__body{flex:1;padding:var(--sl-spacing-5,1.25rem);overflow-y:auto}.sl-offcanvas__footer{padding:var(--sl-spacing-5,1.25rem);border-top:1px solid var(--sl-offcanvas-border-color,hsl(var(--sl-hsl-border)));display:flex;justify-content:flex-end;gap:var(--sl-spacing-2,0.5rem)}.sl-offcanvas__close{display:flex;align-items:center;justify-content:center;width:2rem;height:2rem;padding:0;background:transparent;border:none;border-radius:var(--sl-radius-md,0.5rem);color:hsl(var(--sl-hsl-muted-foreground));font-size:1.5rem;line-height:1;cursor:pointer;transition:background-color var(--sl-transition-normal,200ms) ease,color var(--sl-transition-normal,200ms) ease}.sl-offcanvas__close:hover{background:hsl(var(--sl-hsl-muted));color:hsl(var(--sl-hsl-foreground))}@media (prefers-reduced-motion:reduce){.sl-offcanvas,.sl-offcanvas__backdrop{transition:none}}@media (max-width:48rem){.sl-offcanvas--sm{width:16rem}.sl-offcanvas--md{width:20rem}.sl-offcanvas--lg{width:100%}}";
class o extends HTMLElement {
  constructor() {
    super(), this._backdrop = null, this._returnValue = "", this._pendingOpen = !1, this._savedScrollY = 0, this._closeBtnHandler = null, this._focusableElements = [], this._lastFocusedElement = null, this._shadow = this.attachShadow({ mode: "open" }), this._panel = document.createElement("div"), this._handleEscapeBound = this._handleEscape.bind(this), this._handleBackdropClickBound = this._handleBackdropClick.bind(this), this._render();
  }
  static get observedAttributes() {
    return ["open", "placement", "size", "closable", "backdrop"];
  }
  connectedCallback() {
    (this._pendingOpen || this.hasAttribute("open")) && (this._pendingOpen = !1, Promise.resolve().then(() => {
      this.isConnected && this.hasAttribute("open") && this._open();
    }));
  }
  disconnectedCallback() {
    this._removeEscapeHandler(), this._removeBackdropHandler(), this._enableBodyScroll(), this._restoreFocus();
  }
  attributeChangedCallback(s, t, e) {
    t !== e && (s === "open" ? e !== null ? this._open() : this._close() : s === "placement" || s === "size" ? this._updateStyles() : s === "closable" ? this._updateClosable() : s === "backdrop" && this._updateBackdrop());
  }
  get open() {
    return this.hasAttribute("open");
  }
  set open(s) {
    s ? this.setAttribute("open", "") : this.removeAttribute("open");
  }
  get placement() {
    return this.getAttribute("placement") || "end";
  }
  set placement(s) {
    this.setAttribute("placement", s);
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(s) {
    this.setAttribute("size", s);
  }
  get closable() {
    return !this.hasAttribute("closable") || this.hasAttribute("closable") && this.getAttribute("closable") !== "false";
  }
  set closable(s) {
    s ? this.setAttribute("closable", "true") : this.setAttribute("closable", "false");
  }
  get backdrop() {
    return this.hasAttribute("backdrop");
  }
  set backdrop(s) {
    s ? this.setAttribute("backdrop", "") : this.removeAttribute("backdrop");
  }
  get returnValue() {
    return this._returnValue;
  }
  /**
   * Show the offcanvas panel.
   */
  show() {
    this._open();
  }
  /**
   * Hide the offcanvas panel.
   * @param returnValue - Optional return value
   */
  hide(s) {
    this._returnValue = s || "", this._close();
  }
  /**
   * Toggle the offcanvas panel visibility.
   */
  toggle() {
    this.open ? this.hide() : this.show();
  }
  _open() {
    if (!this.isConnected) {
      this._pendingOpen = !0;
      return;
    }
    this._addEscapeHandler(), this.backdrop && this._addBackdropHandler(), this._disableBodyScroll(), this._trapFocus(), this._panel.classList.add("sl-offcanvas--visible"), this.setAttribute("open", ""), this._dispatch("sl-offcanvas-open");
  }
  _close() {
    this._removeEscapeHandler(), this._removeBackdropHandler(), this._enableBodyScroll(), this._restoreFocus(), this._panel.classList.remove("sl-offcanvas--visible"), this.removeAttribute("open"), this._dispatch("sl-offcanvas-close");
  }
  _handleEscape(s) {
    s.key === "Escape" && (this.closable ? this.hide() : (s.preventDefault(), s.stopPropagation()));
  }
  _handleBackdropClick(s) {
    s.target === this._backdrop && this.closable && this.hide();
  }
  _addEscapeHandler() {
    document.addEventListener("keydown", this._handleEscapeBound);
  }
  _removeEscapeHandler() {
    document.removeEventListener("keydown", this._handleEscapeBound);
  }
  _addBackdropHandler() {
    this._backdrop && this._backdrop.addEventListener("click", this._handleBackdropClickBound);
  }
  _removeBackdropHandler() {
    this._backdrop && this._backdrop.removeEventListener("click", this._handleBackdropClickBound);
  }
  _trapFocus() {
    const s = [
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "a[href]",
      '[tabindex]:not([tabindex="-1"])'
    ].join(", ");
    this._focusableElements = Array.from(this._panel.querySelectorAll(s)), this._focusableElements.length > 0 && (this._lastFocusedElement = document.activeElement, this._focusableElements[0].focus());
  }
  _restoreFocus() {
    this._lastFocusedElement && (this._lastFocusedElement.focus(), this._lastFocusedElement = null);
  }
  _disableBodyScroll() {
    this._savedScrollY = window.scrollY, document.body.style.position = "fixed", document.body.style.top = `-${this._savedScrollY}px`, document.body.style.left = "0", document.body.style.right = "0", document.body.style.overflow = "hidden";
  }
  _enableBodyScroll() {
    document.body.style.position = "", document.body.style.top = "", document.body.style.left = "", document.body.style.right = "", document.body.style.overflow = "", window.scrollTo(0, this._savedScrollY);
  }
  _dispatch(s) {
    this.dispatchEvent(
      new CustomEvent(s, {
        bubbles: !0,
        composed: !0,
        detail: { returnValue: this._returnValue }
      })
    );
  }
  _updateStyles() {
    this._panel.className = `sl-offcanvas sl-offcanvas--${this.placement} sl-offcanvas--${this.size}`;
  }
  _updateClosable() {
    const s = this._shadow.querySelector(".sl-offcanvas__close");
    s && (s.style.display = this.closable ? "flex" : "none");
  }
  _updateBackdrop() {
    this._backdrop && (this._backdrop.style.display = this.backdrop ? "block" : "none");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${a}</style>
      <div class="sl-offcanvas__backdrop" style="display: ${this.backdrop ? "block" : "none"}"></div>
      <div class="sl-offcanvas sl-offcanvas--${this.placement} sl-offcanvas--${this.size}">
        <div class="sl-offcanvas__container">
          <header class="sl-offcanvas__header">
            <slot name="title">
              <h2 class="sl-offcanvas__title"></h2>
            </slot>
            <button class="sl-offcanvas__close" aria-label="Close" ${this.closable ? "" : 'style="display: none"'}>×</button>
          </header>
          <main class="sl-offcanvas__body">
            <slot></slot>
          </main>
          <footer class="sl-offcanvas__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `, this._panel = this._shadow.querySelector(".sl-offcanvas"), this._backdrop = this._shadow.querySelector(".sl-offcanvas__backdrop");
    const s = this._shadow.querySelector(".sl-offcanvas__close");
    s && (this._closeBtnHandler = () => this.hide(), s.addEventListener("click", this._closeBtnHandler));
  }
}
typeof customElements < "u" && !customElements.get("sl-offcanvas") && customElements.define("sl-offcanvas", o);
export {
  o as SlOffcanvasElement
};
//# sourceMappingURL=sl-offcanvas.js.map
